import { useInfiniteQuery } from '@tanstack/react-query';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useGetGroupPostsInfinite(groupId: number) {
  return useInfiniteQuery({
    queryKey: [GroupKey.GROUP_POSTS_INFINITE, groupId],
    queryFn: ({ pageParam }) => GroupService.getGroupPosts(groupId, pageParam).then((response) => response.data),
    initialPageParam: { page: 0, pageSize: 20, sortOrder: 'DESC' as const },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
  });
}
